'use client';

import { MdFacebook } from 'react-icons/md';

import { useTranslations } from 'next-intl';
import NextImage from 'next/image';
import NextLink from 'next/link';

import DiscordIcon from '../DiscordIcon';

function Footer() {
  const t = useTranslations();

  return (
    <div className="w-full md:px-10 py-4 p-4 md:py-8 bg-black mt-6">
      <div className="sm:flex sm:items-center sm:justify-between ">
        <NextLink href="/" className="flex items-center mb-4 sm:mb-0">
          <NextImage
            src="/assets/logo.svg"
            alt={t('images_alts.logo')}
            aria-label={t('images_alts.logo')}
            className="w-[107px] h-[21px]"
            width={107}
            height={21}
          />
        </NextLink>
        <ul className="flex flex-wrap items-center mb-6 text-sm font-medium text-white sm:mb-0">
          <li>
            <NextLink
              href="/privacy-policy"
              className="mr-4 hover:text-gray-200 md:mr-6"
            >
              {t('footer.links.privacy-policy')}
            </NextLink>
          </li>
          <li>
            <NextLink
              href="/terms-of-use"
              className="mr-4 hover:text-gray-200 md:mr-6"
            >
              {t('footer.links.terms-of-use')}
            </NextLink>
          </li>
          <li>
            <NextLink
              href="/data-attribution"
              className="mr-4 hover:text-gray-200 md:mr-6 "
            >
              {t('footer.links.data-attribution')}
            </NextLink>
          </li>
          <li>
            <a
              href="https://trello.com/b/uHxAkj4m"
              target="_blank"
              className="mr-4 hover:text-gray-200 md:mr-6"
              rel="noreferrer"
            >
              {t('footer.links.roadmap')}
            </a>
          </li>
          <li>
            <a
              href="https://www.facebook.com/TrakioApp"
              target="_blank"
              className="mr-4 hover:text-gray-200 flex"
              rel="noreferrer"
            >
              <MdFacebook size={18} />
            </a>
          </li>
          <li>
            <a
              href="https://discord.gg/Q8Dtjey9WC"
              target="_blank"
              className="hover:text-gray-200"
              rel="noreferrer"
            >
              <DiscordIcon className="text-white" width={18} height={18} />
            </a>
          </li>
        </ul>
      </div>
      <hr className="my-6 border-gray-200 sm:mx-auto lg:my-8" />
      <div className="flex flex-row justify-between">
        <div></div>
        <span className="block text-sm text-white sm:text-center">
          © 2025{' '}
          <NextLink href="/" className="hover:text-gray-200 font-bold">
            Trakio
          </NextLink>
        </span>
        <span className="text-white">
          <NextLink
            href="mailto:support@trakio.app"
            className="hover:text-gray-200 font-bold"
          >
            support@trakio.app
          </NextLink>
        </span>
      </div>
    </div>
  );
}

export default Footer;
